"use client";

import { CATEGORIES } from "@/lib/constants";

export default function CategoryTag({ category, small }) {
  const cat = CATEGORIES[category] || CATEGORIES.other;
  return (
    <span
      style={{
        display: "inline-block",
        padding: small ? "1px 6px" : "2px 10px",
        borderRadius: "2px",
        fontSize: small ? "10px" : "11px",
        fontFamily: "var(--font-mono)",
        fontWeight: 500,
        letterSpacing: "0.4px",
        textTransform: "uppercase",
        color: cat.color,
        backgroundColor: `${cat.color}0f`,
        border: `1px solid ${cat.color}30`,
      }}
    >
      {cat.label}
    </span>
  );
}
